const forceInternalUser = false

export default {
  accountType: state => state.accountType,
  loggedIn: state => state.loggedIn,
  isInternalUser: state => state.userType === 'Internal',
  userRole: state => state.userRole,
  minimumAccess: state => state.minimumAccess,
  paperlessSelectionRequired: state => state.paperlessSelectionRequired,
  subGroupAccess: state => state.subGroupAccess,
  groupAccess: state => {
    let groupAccess = {};
    if (state.subGroupAccess) {
      for (let subGroup of state.subGroupAccess) {
        if (!groupAccess[subGroup.groupCk]) {
          // haven't seen this group yet
          groupAccess[subGroup.groupCk] = {
            groupCk: subGroup.groupCk,
            groupEffectiveDate: subGroup.groupEffectiveDate,
            groupId: subGroup.groupId,
            groupName: subGroup.groupName,
            parentGroupCk: subGroup.parentGroupCk,
            access: subGroup.access
          };
        } else {
          // seen the group, recheck the perms
          for (let perm of Object.keys(subGroup.access)) {
            if (subGroup.access[perm] === true) {
              groupAccess[subGroup.groupCk].access[perm] = true;
            }
          }
        }
      }
      return groupAccess;
    }
    return {};
  },
  verifyingToken: state => state.verifyingToken,
  authError: state => state.authError,
  authMessage: state => state.authMessage,
  authValue: state => state.authValue,
  resettingPassword: state => state.resettingPassword,
  updatingPassword: state => state.updatingPassword,
  userId: state => state.userId,
  requestingNewToken: state => state.requestingNewToken,
  tokenUserMessage: state => state.tokenUserMessage,
  updatePasswordErrorMessage: state => state.updatePasswordErrorMessage,
  authFailed: state => state.authFailed,
  loggingIn: state => state.loggingIn,
  lockoutWarningCounter: state => state.lockoutWarningCounter,
  authErrorMessage: state => state.authErrorMessage,
  authStatus: state => state.authStatus,
  isSsoUser: state => state.isSsoUser,
  userFirstName: state => state.userFirstName,
  userLastName: state => state.userLastName,
  tokenError: state => state.tokenError,
  ssoAuthError: state => state.ssoAuthError,
  ssoAuthErrorMessage: state => state.ssoAuthErrorMessage,
  userAccountType: state =>
    state.userType === 'Internal' ? 'internal' : state.accountType,
  termsAndConditionsAccepted: state => state.termsAndConditionsAccepted,
  smsReminder: state => state.smsReminder,
  smsEnabled: state => state.smsEnabled,
  closeSmsPrompt: state => state.closeSmsPrompt
}